import { CACHE_MUTATIONS } from './constants';

export function persistStoreCache({ commit }, cache) {
    commit(CACHE_MUTATIONS.SAVE_STORE_CACHE, cache);
}
